import { SearchRequest } from '@empathy/search-adapter';
import { Facet, Filter, RelatedTag } from '@empathy/search-types';
import { EmpathyXConfig, QueryOrigin, SearchState } from '../../../models';
import { Dictionary, isArrayEmptyOrNull } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class SearchRequestGetter implements SearchGetter {
  getters = {
    [SEARCH_GETTERS_KEYS.searchRequest]: (state: SearchState, getters: any, rootState: RootStoreState, rootGetters: any): SearchRequest => {
      const { resultsGrid: gridConfig }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const relatedTags: RelatedTag[] = rootGetters[GETTERS_KEYS.querySignals.selectedRelatedTags];
      const start = state.keepPreviousResults ? state.results.length : 0;
      const filters: Dictionary<Filter[]> = getters[SEARCH_GETTERS_KEYS.selectedFiltersByFacet];
      return {
        query: state.query.trim(),
        rows: gridConfig.pageSize * state.page - start,
        start,
        sort: state.sort.value || undefined,
        filters,
        relatedTags,
        origin: rootState.tracking.queryOrigin
      };
    },
    [SEARCH_GETTERS_KEYS.searchRequestNextQueryResults]: (state: SearchState, getters: any, rootState: RootStoreState,
      rootGetters: any): SearchRequest => {
      const { nextQueries: { results: resultsNumber } }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const filters: Dictionary<Filter[]> = rootGetters[GETTERS_KEYS.querySignals.nextQueriesFilters];
      return {
        query: '',
        rows: resultsNumber,
        start: 0,
        sort: state.sort.value || undefined,
        filters,
        relatedTags: [],
        origin: QueryOrigin.nextQueryGrid
      };
    }
  };
}
